export const api = process.env.REACT_APP_API_HOST || 'http://localhost:5000'
//const api = 'https://exploring-ai-api.herokuapp.com'
//console.log(process.env.REACT_APP_API_URL)
export const submitSearchRequest = (query, params=[]) =>
  fetch(api+'/fsearch?q='+query+'&'+params.join('&'))
    .then(res => res.json())
      .then(
        //console.log(api+'/fsearch?q='+query+'&'+params.join('&'))
      )



// WEBPACK FOOTER //
// ./src/utils/api.js